import React, { useContext, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import InputSelectCustom from '../InputSelectCustom';
import { ConfigurationContext, ContentContext } from '../../../context';
import { useTranslation } from 'react-i18next';
import { DateTime } from "luxon";
import LabelCustom from '../LabelCustom';
import LoaderComponent from '../LoaderComponent';
import { set } from 'ramda';

const WrapperStyled = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    .label_custom{
        margin-bottom: 5px;
    }
    .uploader-file{
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        .loader{
            margin-right: 10px;
        }
        .preloader{
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
            line-height: 16px;
            font-weight: 800;
            margin-right: 10px;
            background-color: ${props => `rgb(${props.pancolors.light_gray})`};
            color: ${props => `rgb(${props.pancolors.dark_gray})`};
            padding: 8px 8px;
            border-radius: 6px;
            p{
                margin: 0;
                padding: 0;
            }
        }
    }
`

const UploaderFileContainer = (props) => {

    const { t } = useTranslation();

    const { scope,
            className,
            contentByLang,
            setContentByLang,
            lang,
            item } = props;

    const { panColors, 
            userCountrySelected } = useContext(ConfigurationContext);

    const { getByPassImageUploadRoute } = useContext(ContentContext);

    const [ isUploading, setIsUploading ] = useState(false);
    const [ percent, setPercent ] = useState(0);
    const [ fileName, setFileName ] = useState(null);

    const formStyle = {background_color: `rgba(${panColors.white}, 1)`,
                       border_color: `rgba(${panColors.middle_gray}, 1)`};
    
    let abortControllerRef = useRef();

    const handleFormElementChange = (name, value) => {
        //console.log("👉", name, value)
        if(value){
            handleRawFile(value);
        }
        /*
        let updateData = {...contentByLang.translations[lang].certificate};
        updateData[name].value = value;

        let contentByLangUpdate = {...contentByLang};
        contentByLangUpdate.translations[lang].certificate = {...updateData};
        setContentByLang(contentByLangUpdate);

        console.log("💜", contentByLangUpdate);
        */
        /*
        let updateData = {...data};
            
            switch (name) {
                case 'description_short':
                    
                    updateData[name].value = value;
    
                    break;
    
                case 'description_long':
                    
                    updateData[name].value = value;
    
                    break;
    
                case 'title':
                    
                    let valid_title = validateNoTagsHTML(value);
                    if(valid_title){
                        updateData[name].error = true;
                    }else{
                        updateData[name].error = false;
                    }
                    updateData[name].value = value;
    
                    break;
                    
                default:
    
                    updateData[name].value = value;
    
                    break;
            }
    
            let contentByLangUpdate = {...contentByLang};
            contentByLangUpdate[lang] = updateData;
            setContentByLang(contentByLangUpdate);
            
            return null;
            */
    }

    const subirArchivoAS3 = (imageProfileUploadURL, archivo) => {
        
        return new Promise((resolve, reject) => {

            abortControllerRef.current = new AbortController()

            const reader = new FileReader();

            reader.onload = () => {
                const archivoData = reader.result;
                var config = { headers: { 'Content-Type': archivo.type, },
                               signal: abortControllerRef.current.signal, 
                               onUploadProgress: function(progressEvent) {
                                setPercent(Math.round( (progressEvent.loaded * 100) / progressEvent.total ));
                               }
                            };
                axios.put(imageProfileUploadURL, archivoData, config).then(() => {
                    resolve(imageProfileUploadURL.split('?')[0]);
                }).catch((error) => {
                    reject(error.message);
                });
            };
            
            reader.onerror = (error) => {
                reject(error);
            };
            
            reader.readAsArrayBuffer(archivo);
        });

    };

    const handleRawFile = (file) => {

            //return null;
            
            //const size_limit_video = 75;
            //const size_limit_audio = 15;
            //const size_limit_archives = 30;
            //const size_limit_images = 10;

            let content_type = '';
            let message = '';
            let isValid = true;
            const file_type = file.type.split("/");
            const name = file.name;
            const extension = name.split('.').pop();
            const mime_type = file_type[0];
            const mime_extension = file_type[1];
            const size = ((file.size / 1024) / 1024);


            setIsUploading(true);

            const datetime = DateTime.fromMillis(Date.now());
            const filename = datetime+"."+extension;
            const payload = { name: filename,
                              path: "certificates/" };
            
            const uploadRoute = getByPassImageUploadRoute(payload, "image/jpeg");
            uploadRoute.then((res) => {
                //console.log("👍", res);
                
                subirArchivoAS3(res, file)
                .then((mensaje) => {
                    //console.log("🤟🏽", mensaje);
                    setFileName(mensaje);
                    let contentByLangUpdate = {...contentByLang};
                        contentByLangUpdate.translations[lang].certificate[item].value = mensaje;
                        //contentByLangUpdate[lang].medias.push(slide);
                        setContentByLang(contentByLangUpdate);

                    setIsUploading(false);
                    setPercent(0);

                })
                .catch((error) => {
                    //console.log("☠️", error);
                    //inputFileRef.current.value = '';
                    //setLoadingMediaFile(false);
                    //setPercent(null);
                });
                
            })
            /*
            
            setFileErrorMessage("");
            
            const payload = { name: filename,
                                path: "courses/" };
            
            setGettingUploadUrl(true);
            const uploadRoute = getByPassImageUploadRoute(payload, "image/jpeg");
            uploadRoute.then((res) => {
                setGettingUploadUrl(false);
                setPercent(0);
                subirArchivoAS3(res, file)
                .then((mensaje) => {
                    setPercent(null);
                    if(scope !== "categories"){
                        const slide = {id: `item${contentByLang[lang].medias.length+1}`, 
                                    name: `Item ${contentByLang[lang].medias.length+1}`, 
                                    media_type: content_type, 
                                    media_url: mensaje,
                                    media_name: name.length > 40 ? shortenFileName(name, 15) : name};
                        
                        let contentByLangUpdate = {...contentByLang};
                        contentByLangUpdate[lang].medias.push(slide);
                        setContentByLang(contentByLangUpdate);
                    }
                    if(scope === "categories"){
                        
                        const slide = {id: `item1`, 
                                    name: `Item1`, 
                                    media_type: content_type, 
                                    media_url: mensaje,
                                    media_name: name.length > 40 ? shortenFileName(name, 15) : name};
                        
                        let updateData = {...contentByLang};
                        updateData.translations[lang].image_big = slide;
                        updateData.translations[lang].medias = [slide];
                        setContentByLang(updateData);
                    }
                    
                    setLoadingMediaFile(false);
                    inputFileRef.current.value = '';

                    if(content_type === "Archives"){
                        setApplicationCount(1);
                    }
                })
                .catch((error) => {
                    inputFileRef.current.value = '';
                    setLoadingMediaFile(false);
                    setPercent(null);
                });
            })
            */







            /*
            if (size > 1) {
                isValid = false;
                message = t("El archivo supera el tamaño máximo permitido de 1MB.");
            } else {
                isValid = true;
                message = "";
            }

            if(isValid){
                alert("El archivo es válido");
            }else{
                alert("El archivo no es válido");
            }

            console.log("💚", mime_type, mime_extension, size, extension);
            */

            return null;

    }

    /*
    const handleRawFile = (e) => {

        if(e.target.files.length){
            
            const file = e.target.files[0];
            console.log("💚", file);
            //const size_limit_video = 75;
            //const size_limit_audio = 15;
            //const size_limit_archives = 30;
            //const size_limit_images = 10;

            let content_type = '';
            let message = '';
            let isValid = true;
            const file_type = file.type.split("/");
            const name = file.name;
            const extension = name.split('.').pop();
            const mime_type = file_type[0];
            const mime_extension = file_type[1];
            const size = ((file.size / 1024) / 1024);
            
            return null;
        }
    }
    */
    const handleCancel = () => {
        if(abortControllerRef.current){
            abortControllerRef.current.abort();
        }

        const contentByLangUpdate = {...contentByLang};
        contentByLangUpdate.translations[lang].certificate[item].value = "";
        setContentByLang(contentByLangUpdate);

        setPercent(0);
        setIsUploading(false);
    }
    /*
    useEffect(() => {
      console.log("🎃", item, lang, contentByLang.translations[lang].certificate[item].value, contentByLang)
    
      return () => { }
    }, [contentByLang])
    */

    if(Object.keys(contentByLang.translations[lang].certificate[item]).length === 0){
        return null;
    }

    return (
        <WrapperStyled 
            pancolors={panColors}
            className={`uploader-file-container ${className}`}
        >
            <LabelCustom 
                name={contentByLang.translations[lang].certificate[item].ref}
                label={t("texts."+contentByLang.translations[lang].certificate[item].label)}
                styles={ formStyle }
                label_icon={null}
                isRequired={contentByLang.translations[lang].certificate[item].required}
                tooltip_content={contentByLang.translations[lang].certificate[item].tooltip && t("texts."+contentByLang.translations[lang].certificate[item].tooltip)}
            />
            <div className="uploader-file">

                {isUploading ?
                    <div className='preloader'>
                        <p>{ percent }%</p>
                    </div>
                : ""}
                
                {(isUploading && !fileName) ?
                    <div className='loader'>
                        <LoaderComponent size={20}/>
                    </div>  
                : ""} 

                <InputSelectCustom 
                    name={contentByLang.translations[lang].certificate[item].ref}
                    label={null}
                    placeholder={t("texts."+contentByLang.translations[lang].certificate[item].placeholder)}
                    onChange={handleFormElementChange}
                    onKeyDown={null}
                    className={`field field_${contentByLang.translations[lang].certificate[item].ref}${contentByLang.translations[lang].certificate[item].error ? " error" : ""}`}
                    type="text"
                    value={contentByLang.translations[lang].certificate[item].value}
                    help={contentByLang.translations[lang].certificate[item].help}
                    isRequired={contentByLang.translations[lang].certificate[item].required}
                    styles={ formStyle }
                    label_icon={null}
                    //tooltip_content={null}
                    tooltip_content={contentByLang.translations[lang].certificate[item].tooltip && t("texts."+contentByLang.translations[lang].certificate[item].tooltip)}
                    haveError={contentByLang.translations[lang].certificate[item].error}
                    isUploading={isUploading}
                    fileName={fileName}
                    setFileName={setFileName}
                    handleCancel={handleCancel}
                    scope={scope}
                />
            </div>
        </WrapperStyled>
    );
};

export default UploaderFileContainer;